export enum ShopFulfillmentMethod {
  SHIP = "SHIP",
  PICKUP = "PICKUP",
}
